import { Dropdown } from 'components/core';
import { FC } from 'react';
import { SortDirection } from 'types';
import { Styled, ProductListingHeaderProps } from '.';
import { useI18n } from 'contexts/i18n';

const ProductListingHeader: FC<ProductListingHeaderProps> = ({
  title,
  totalProductCount,
  onSort,
  sortDirection,
  isLoading = false,
}) => {
  const i18n = useI18n();
  return (
    <Styled.TaxonHeaderContainer>
      <Styled.TaxonTitle>{title}</Styled.TaxonTitle>
      {!isLoading && (
        <Styled.TaxonControls>
          {typeof totalProductCount !== 'undefined' && (
            <Styled.ProductCount>
              {totalProductCount > 0 && (
                <>
                  {totalProductCount} {i18n['Products Found']}
                </>
              )}
              {totalProductCount == 0 && <>{i18n['No Products found.']}</>}
            </Styled.ProductCount>
          )}

          {onSort && (
            <Dropdown
              label={i18n['Sort by']}
              selectedValue={sortDirection}
              options={[
                { label: i18n['Sort by'], value: '' },
                {
                  label: i18n['Alphabetically: A-Z'],
                  value: SortDirection.AlphaAsc,
                },
                {
                  label: i18n['Alphabetically: Z-A'],
                  value: SortDirection.AlphaDesc,
                },
                {
                  label: i18n['Price: Low to High'],
                  value: SortDirection.PriceAsc,
                },
                {
                  label: i18n['Price: High to Low'],
                  value: SortDirection.PriceDesc,
                },
                {
                  label: i18n['Newest First'],
                  value: SortDirection.NewestFirst,
                },
                {
                  label: i18n['Oldest First'],
                  value: SortDirection.OldestFirst,
                },
              ]}
              onChange={val => {
                onSort && onSort(val as SortDirection);
              }}
              width="100%"
            />
          )}
        </Styled.TaxonControls>
      )}
    </Styled.TaxonHeaderContainer>
  );
};

export default ProductListingHeader;
